module.exports = __webpack_public_path__ + "img/网站3-35.d30ae3ed.png";